import React, { useEffect } from "react";
import * as d3 from "d3";

const WaterFlowPipeline = () => {
  useEffect(() => {
    const width = 800;
    const height = 400;

    const svg = d3
      .select("#pipeline-svg")
      .attr("width", width)
      .attr("height", height);

    svg.selectAll("*").remove();

    // 定义管道的路径
    const pathData = "M50,200 L250,200 L250,100 L450,100 L450,200 L650,200 L700,100 L100,400 A25,25 0 1,0 50,0";

    // 绘制管道路径
    const path = svg
      .append("path")
      .attr("d", pathData)
      .attr("fill", "none")
      .attr("stroke", "black")
      .attr("opacity", "10%")
      .attr("stroke-width", 10);

    // 获取路径的总长度
    const totalLength = path.node().getTotalLength();

    // 创建渐变定义
    const defs = svg.append("defs");
    const linearGradient = defs
      .append("linearGradient")
      .attr("id", "water-gradient")
      .attr("x1", "0%")
      .attr("y1", "0%")
      .attr("x2", "100%")
      .attr("y2", "0%");

    linearGradient
      .append("stop")
      .attr("offset", "0%")
      .style("stop-color", "rgb(0,255,255)")
      .style("stop-opacity", 1);

    linearGradient
      .append("stop")
      .attr("offset", "100%")
      .style("stop-color", "rgb(0,0,255)")
      .style("stop-opacity", 1);



    // 动画效果
    let position = 0; // 水流的起始位置
    const speed = 10; // 水流的速度
    const flowLength = 120; // 水流线段的长度


    // 计算水流线段的起始和结束位置
    const flowDataFn = (start) => {
        var points = [];
        for(var i = start; i < start+flowLength; i = i+flowLength/20){
            var point = path.node().getPointAtLength(i);
            points.push(point); // 将点添加到数组中
        }

        // 初始化d属性
        var d = "";

        // 遍历点数组
        for (var i = 0; i < points.length; i++) {
            // 对于第一个点，使用移动到（M）命令
            if (i === 0) {
                d += "M" + points[i].x + "," + points[i].y;
            } else {
                // 对于后续的点，使用线到（L）命令
                d += " L" + points[i].x + "," + points[i].y;
            }
        }

        // 关闭路径，形成一个闭合的环路
        // d += " Z";

        // 返回创建的路径元素
        return d;
    }

    // 创建水流的线段
    const waterFlow = svg
    .append("path")
    .attr("d", flowDataFn(position))
    .attr("stroke", "red")
    //.attr("stroke", "url(#water-gradient)")
    .attr("stroke-width", 6)
    .attr("fill", "none"); // 防止路径填充;





    const animateWaterFlow = () => {
      position += speed; // 更新水流位置
      if (position > totalLength) position = 0; // 如果超过总长度，重置

       const newData = flowDataFn(position);

      // 更新水流线段的位置
      waterFlow
      .attr("d", newData);

      requestAnimationFrame(animateWaterFlow); // 使用 requestAnimationFrame 进行动画
    };

    animateWaterFlow(); // 启动水流动画
  }, []);

  return <svg id="pipeline-svg"></svg>;
};

export default WaterFlowPipeline;
